import { Trend, PulsarPayload, BreakdownItem } from "ExtendiApp"

const validateBreakdown = ({ date, value }: BreakdownItem) => {
  const isValidDate = Boolean(date && new Date(date).getTime())
  const isValidValue = Boolean(parseInt(`${value}`) >= 0)

  const isValid = isValidDate && isValidValue

  if (!isValid) {
    console.error("Invalid breakdown item", { date, value })
    console.info("isValidDate: ", isValidDate)
    console.info("isValidValue: ", isValidValue)
  }

  return isValidDate && isValidValue
}

const validateTrendJson = (json: PulsarPayload) => {
  return Boolean(
    json &&
      json.length &&
      json.every(
        item =>
          item.breakdown.length &&
          item.breakdown &&
          item.breakdown.every(validateBreakdown)
      )
  )
}

export const validateTrend = (trend: Trend): boolean => {
  const isValidTopic = Boolean(trend && trend.topic)
  const isValidTrendUrl = Boolean(trend && trend.url)
  const isValidJson = Boolean(
    trend && trend.json && validateTrendJson(trend.json)
  )

  const isValid = isValidTopic && isValidTrendUrl && isValidJson

  if (!isValid) {
    console.error("trend: ", trend)
    console.info("isValidTopic :", isValidTopic)
    console.info("isValidTrendUrl :", isValidTrendUrl)
    console.info("isValidJson :", isValidJson)
  }
  return isValidTopic && isValidTrendUrl && isValidJson
}
